/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Zotero_Browser_Import_ErrorInputs */

const en_zotero_browser_import_error = /** @type {(inputs: Zotero_Browser_Import_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to import from Zotero`)
};

const es_zotero_browser_import_error = /** @type {(inputs: Zotero_Browser_Import_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo importar desde Zotero`)
};

/**
* | output |
* | --- |
* | "Failed to import from Zotero" |
*
* @param {Zotero_Browser_Import_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const zotero_browser_import_error = /** @type {((inputs?: Zotero_Browser_Import_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Zotero_Browser_Import_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_zotero_browser_import_error(inputs)
	return en_zotero_browser_import_error(inputs)
});